<template>
  <div>
    <ul
      class="grid gap-y-12 lg:grid-cols-12 md:grid-cols-6 lg:gap-10 md:gap-5 sm:gap-10 sm:mt-16"
    >
      <li
        v-for="trip in results"
        :key="trip.id"
        class="lg:col-span-4 md:col-span-3 relative"
      >
        <a :href="`${trip.supplier_url}?from=${getFrom(trip)}`">
          <div class="aspect-ratio-3/2 overflow-hidden relative rounded">
            <img
              class="absolute w-full h-full object-cover object-center"
              :src="getCloudinaryImage(trip.supplier_image_url)"
            />
          </div>
          <span
            class="discount-tag absolute top-0 text-white rounded-tr rounded-bl py-2 px-8 text-sm leading-5"
          >
            <currency-aware-discount-tag :trip="trip" />
          </span>
          <h4 class="fs-20 font-medium lh-130 pt-4">
            {{ trip.itineraries.name }}
          </h4>
          <div class="flex text-sm font-medium leading-6 pt-1 items-center">
            <p class="text-secondary">{{ trip.supplier_name }}</p>
            <div class="flex-none mx-1 text-black-light-4">•</div>
            <span class="text-black-light-4">
              {{ trip.country_name }}
            </span>
          </div>
          <span class="font-medium pt-1">{{ formatDates(trip) }}</span>
          <div class="flex-none flex items-center pt-1">
            <div class="flex items-center">
              <svg width="20" height="20" class="flex-none mr-2">
                <use xlink:href="/img/sprite.svg#ic_calendar"></use>
              </svg>
              {{ trip.itineraries.itinerary_length + 1 }}D /
              {{ trip.itineraries.itinerary_length }}N
            </div>
            <div class="ml-6 flex-none flex items-center">
              <svg width="20" height="20" class="flex-none mr-1">
                <use xlink:href="/img/sprite.svg#ic_diving"></use>
              </svg>
              <span class="dives-count inline-block">
                {{ trip.itineraries.dive_number }} dives
              </span>
            </div>
          </div>
          <p class="text-sm font-medium leading-6 pt-2">
            <span class="line-through mr-1">
              <currency-context>
                <template v-slot="{ convert }">
                  <span v-text="convert(getPrices(trip.prices)[0])"></span>
                </template>
              </currency-context>
            </span>
          </p>
          <h4 class="fs-20 lh-130 font-medium discount-price pt-1">
            <currency-context>
              <template v-slot="{ convert }">
                <span v-text="convert(getPrices(trip.prices)[1])"></span>
              </template>
            </currency-context>
            <span class="font-normal text-base"> /guest </span>
          </h4>
        </a>
      </li>
    </ul>

    <div class="w-fit-content sm:w-full m-auto mt-16 sm:mb-16 flex flex-col">
      <button
        :disabled="isLoading"
        v-if="visibleShowMore"
        @click="$emit('show-more')"
        class="btn-show-more btn btn-outlined btn-secondary w-full flex items-center"
      >
        Show more
        <div v-if="isLoading" class="loader ml-2" />
      </button>
    </div>
  </div>
</template>

<script>
import { displayDate } from "../../helpers/specialDealsHelpers";
import { getCloudinaryUrl } from "../../helpers";
import CurrencyContext from "../core/CurrencyContext";
import CurrencyAwareDiscountTag from "./CurrencyAwareDiscountTag";

export default {
  components: {
    CurrencyContext,
    CurrencyAwareDiscountTag,
  },
  props: {
    datetime: {
      type: Array,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    results: {
      type: Array,
      default: [],
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    visibleShowMore() {
      return this.results.length < this.count;
    },
  },
  methods: {
    getFrom(trip) {
      if (this.datetime[0]) {
        return this.datetime[0].format("YYYY-MM-DD");
      }

      return moment(trip.departure_date, "YYYY-MM-DD")
        .startOf("month")
        .format("YYYY-MM-DD");
    },
    formatDates(trip) {
      const start_date = moment(trip.departure_date, "YYYY-MM-DD");
      const end_date = moment(trip.departure_date, "YYYY-MM-DD").add(
        trip.itineraries.itinerary_length,
        "days"
      );
      return displayDate(start_date, end_date);
    },
    getPrices(prices) {
      const validPrice = prices.find((_p) => _p.lowest_price);
      return [validPrice.real_price, validPrice.final_price];
    },
    getCloudinaryImage(url) {
      return getCloudinaryUrl(url, { width: 600 });
    },
  },
};
</script>

<style scoped>
.dives-count:first-letter {
  text-transform: uppercase;
}

.discount-tag {
  right: -2px;
}

.btn-show-more {
  width: 200px;
  justify-content: center;
}

@media (max-width: 600px) {
  .btn-show-more {
    width: 100%;
    justify-content: center;
  }
}

.loader {
  border: 2px solid #dbdbdb;
  border-radius: 50%;
  border-top: 2px solid #1695a3;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
